// @flow
import React from 'react';

import { BaseHeading } from './BaseHeading';

export const StyledH1 = ({ text, inline = false }) => (
  <BaseHeading as="h1" inline={inline} text={text} />
);
